import { render, staticRenderFns } from "./ModifySystemAccountTokenBtn.vue?vue&type=template&id=84b40a32&"
import script from "./ModifySystemAccountTokenBtn.vue?vue&type=script&lang=js&"
export * from "./ModifySystemAccountTokenBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports